const TABS = {
  ANAGRAFICA: "anagrafica",
  CARTELLA: "cartella",
  ISEE: "isee",
  ISCRIZIONI: "iscrizioni",
  PAGAMENTI: "pagamenti",
};

const UserTabs = ({ activeTab, onChange }) => (
  <ul className="nav nav-tabs auto">
    <li className="nav-item">
      <button
        className={`nav-link ${activeTab === TABS.ANAGRAFICA ? "active" : ""}`}
        onClick={() => onChange(TABS.ANAGRAFICA)}
      >
        Anagrafica
      </button>
    </li>

    <li className="nav-item">
      <button
        className={`nav-link ${activeTab === TABS.CARTELLA ? "active" : ""}`}
        onClick={() => onChange(TABS.CARTELLA)}
      >
        Cartella sociale
      </button>
    </li>

    <li className="nav-item">
      <button
        className={`nav-link ${activeTab === TABS.ISEE ? "active" : ""}`}
        onClick={() => onChange(TABS.ISEE)}
      >
        ISEE
      </button>
    </li>

    <li className="nav-item">
      <button
        className={`nav-link ${activeTab === TABS.ISCRIZIONI ? "active" : ""}`}
        onClick={() => onChange(TABS.ISCRIZIONI)}
      >
        Iscrizioni
      </button>
    </li>

    <li className="nav-item">
      <button
        className={`nav-link ${activeTab === TABS.PAGAMENTI ? "active" : ""}`}
        onClick={() => onChange(TABS.PAGAMENTI)}
      >
        Pagamenti
      </button>
    </li>
  </ul>
);

export { TABS };
export default UserTabs;
